import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, Clock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) {
      setStatus("pending");
      return;
    }
    let attempts = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
      } catch (e) {
        // keep polling
      }
      attempts += 1;
      if (attempts < 10) {
        timer = setTimeout(poll, 2000);
      } else {
        setStatus("pending");
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FBF9F4] px-4">
      <div
        data-testid="payment-success-page"
        className="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-10 text-center shadow-xl shadow-blue-900/5"
      >
        {status === "checking" && (
          <>
            <Loader2 className="mx-auto h-12 w-12 animate-spin text-blue-600" />
            <h1 className="mt-5 font-display text-2xl font-bold text-slate-900">
              Confirming your payment…
            </h1>
            <p className="mt-2 text-sm text-slate-500">This only takes a few seconds.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-blue-700 text-white">
              <CheckCircle2 className="h-7 w-7" />
            </span>
            <h1
              data-testid="payment-confirmed-heading"
              className="mt-5 font-display text-2xl font-bold text-slate-900"
            >
              Welcome aboard!
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              Your subscription is confirmed. John will personally reach out within one business day
              with your next steps and access details.
            </p>
          </>
        )}
        {status === "pending" && (
          <>
            <Clock className="mx-auto h-12 w-12 text-amber-500" />
            <h1 className="mt-5 font-display text-2xl font-bold text-slate-900">
              Payment processing
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              We're still confirming your payment. If you were charged, you're all set — John will
              reach out shortly.
            </p>
          </>
        )}
        <Link
          to="/"
          data-testid="payment-success-home-link"
          className="mt-8 inline-flex items-center justify-center rounded-xl bg-blue-700 px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-blue-800"
        >
          Back to nowlifeworks.com
        </Link>
      </div>
    </div>
  );
}
